export default "__VITE_ASSET__03VtTGAL__"